// TODO: この検索モジュールをVueで記述する
//       モーダルの実装を.vueに置き換える必要がある

$(() => {
  if(document.getElementById('initial-form-binding') === null) return;
  
  // ダイアログにdata-urlがあれば、表示時に内容をそこからロード
  $(document).on('show.bs.modal', '.modal', e => {
    const dialog = $(e.currentTarget);
    const url = dialog.data('url');
    if(!url) {
      return;
    }
    dialog.load(url);
  });

  Number.prototype.numberWithDelimiter = function(delimiter) {
    const number = this + '';
    delimiter = delimiter || ',';
    const split = number.split('.');
    split[0] = split[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      '$1' + delimiter
    );
    return split.join('.');
  };
  
  const updateCount = (count, counterSelector) => {
    const countNode = $(counterSelector);
    let oldCount = parseInt(countNode.text().replace(',', ''));
    if(isNaN(oldCount)) {
      oldCount = count;
    }
    // IE8以前だと実在するcssのスタイルを通してしかanimateできないためダミー要素を作る
    $('<div style="left: ' + oldCount + 'px;"></div>').animate({ left: count }, {
      duration: 500,
      easing: 'linear',
      step(current){
        countNode.text(Math.floor(current).numberWithDelimiter(',') + '件');
      },
      complete(){
        countNode.text(count.numberWithDelimiter(',') + '件');
      }
    });
  }
  
  const refreshSearchCount = (countContainerSelector, setupModeParams) => {
    let params = $('#new_search_condition').serializeArray();
  
    const countContainer = $(countContainerSelector);
  
    params = setupModeParams(params);
    if(params === null) {
      countContainer.text('- 件');
      return;
    }
  
    const url = countContainer.data('url');
    $.getJSON(url, params, data => {
      updateCount(data.count, countContainerSelector);
    }).fail(() => {
      countContainer.text('- 件');
    });
  };

  /* 条件をリクエストできる形式に組み立てて、検索する */

  const closeModal = () => {
    const dialog = $('.modal');
    dialog.unbind('hidden.bs.modal');
    dialog.modal('hide');
  }
  
  /*******************************************
    検索条件(地域モーダル)
    都道府県、市区町村から求人を検索する
  *******************************************/
  
  /* 条件(都道府県、市区町村)に当てはまる求人件数の表示を更新 */
  const refreshAreaSearchCount = () => {
    refreshSearchCount('#area-search-count', () => {
      const optionParams = [];
      const checkedCities = $('input[type=checkbox]:checked', '#area-search-popup');
      const selectedPrefectureId = $('#select_area_prefecture_id option:selected').val();
      // モーダルを開いている間はbinding_formの値は一切更新しないようにしている。
      // ただArea検索条件を決める場合、bindingFormParamsOnCheckboxChangedのタイミングで市区町村にチェックが入っているにも関わらず
      // 都道府県検索モードになるケースがでてくる(モーダルを開いたときに都道府県のみ選択されている -> 市区町村を選択してもbinding_formに市区町村はモーダルが閉じるまで入らない)
      // このため、一時的にbinding_formの市区町村を更新することで適切な検索モードに切り替えた上で求人票件数の検索を行わせる
      const cityIds = [];
      const actualCityIds = bindingForm.city_id_array();
      optionParams.push({ name: 'cities_prefecture_id', value: selectedPrefectureId });
      checkedCities.map((_, element) => {
        cityIds.push($(element).val());
        optionParams.push({ name: 'search_condition[city_id_array][]', value: $(element).val() });
      });
      bindingForm.prefecture_id(selectedPrefectureId);
      bindingForm.city_id_array(cityIds);
      const bindingFormParamsForReturn = bindingFormParamsOnCheckboxChanged('city_id_array', optionParams);
      bindingForm.city_id_array(actualCityIds);
      return bindingFormParamsForReturn;
    });
  };
  
  /* モーダルを呼び出す */
  const callAreaSearchModal = () => {
    const dialog = $('#area-search-popup');
    bindingForm.citiesSearchPath(urlWithSearchQuery(bindingForm.citiesSearchPath(), bindingFormParams([
      { name: 'cities_prefecture_id', value: bindingForm.prefecture_id }
    ])));
    dialog.load(bindingForm.citiesSearchPath(), () => {
      refreshAreaSearchCount();
      dialog.modal('show');
      $('.m3p-modal__btn').text('選択した条件で絞り込む');
    });
  }

  /* モーダルを`条件を設定した上で`閉じる */
  const applyAreaToSearchCondition = () => {
    const selectedCities = $('input[type=checkbox]:checked', '#area-search-popup');
    const selectedPrefectureId = $('#select_area_prefecture_id option:selected').val();
    const selectedPrefectureText = $('#select_area_prefecture_id option:selected').text();
    const cityIds = [];
    selectedCities.map((_, element) => cityIds.push($(element).val()));
    bindingForm.prefecture_id(selectedPrefectureId);
    bindingForm.city_id_array(cityIds);
    bindingForm.prefectureText(selectedPrefectureText);
    changeBindingTextOnSearchModule('city-checkbox', 'cityText', '市区町村');
    bindingForm.sm(searchMode());
    placeInactiveClassToCallingModalButton('#city-search-button', isEnableToCallCityModal());
    closeModal();
  }

  $(document).on('click', '#prefecture-search-button', () => callAreaSearchModal());
  $(document).on('click', '#tohan__search_form #city-search-button', () => callAreaSearchModal());
  $(document).on('click', '#city-search-button', () => {
    if(!isEnableToCallCityModal()) return;
    callAreaSearchModal();
  });
  $(document).on('change', '#area-search-popup input[type=checkbox]', refreshAreaSearchCount);
  $(document).on('click', '#submit-area-search', applyAreaToSearchCondition);

  // 「市区町村」モジュールをクリックしてモーダルを呼び出して良いか判定する
  const isEnableToCallCityModal = () => {
    return bindingForm.prefecture_id() !== "";
  }

  /*******************************************
    検索条件(雇用形態モーダル)
    雇用形態から求人を検索する
  *******************************************/

  /* 条件(雇用形態)に当てはまる求人件数の表示を更新 */
  const refreshEmploymentTypeSearchCount = () => {
    refreshSearchCount('#employment-type-search-count', () => {
      const selectedEmploymentTypes = $('input[type=checkbox]:checked', '#employment-type-search-popup');
      const employmentTypeIds = [];
      selectedEmploymentTypes.map((_, element) => {
        employmentTypeIds.push({ name: 'search_condition[employment_status_id_array][]', value: $(element).val() })
      });
      return bindingFormParamsOnCheckboxChanged('employment_status_id_array', employmentTypeIds);
    });
  };

  /* モーダルを呼び出す */
  const callEmploymentTypeSearchModal = () => {
    const dialog = $("#employment-type-search-popup");
    $('input[type=checkbox]:checked', '#employment-type-search-popup');
    bindingForm.employmentTypeSearchPath(urlWithSearchQuery(bindingForm.employmentTypeSearchPath(), bindingFormParams()));
    dialog.load(bindingForm.employmentTypeSearchPath(), () => {
      refreshSearchCount('#employment-type-search-count', () => bindingFormParams());
      dialog.modal('show');
      $('.m3p-modal__btn').text('選択した条件で絞り込む');
    });
  }

  /* モーダルを`条件を設定した上で`閉じる */
  const applyEmploymentTypeToSearchCondition = () => {
    const selectedEmploymentTypes = $('input[type=checkbox]:checked', '#employment-type-search-popup');
    const employmentTypeIds = [];
    selectedEmploymentTypes.map((_, element) => employmentTypeIds.push($(element).val()));
    bindingForm.employment_status_id_array(employmentTypeIds)
    changeBindingTextOnSearchModule('employment-type-checkbox', 'employmentTypeText', '雇用形態');
    closeModal();
  }

  $(document).on('click', '#employment-type-search-button', () => callEmploymentTypeSearchModal());
  $(document).on('change', '#employment-type-search-popup input[type=checkbox]', refreshEmploymentTypeSearchCount);
  $(document).on('click', '#submit-employment-type-search', applyEmploymentTypeToSearchCondition);

  /*******************************************
    検索条件(業種モーダル)
    業種から求人を検索する
  *******************************************/

  /* 条件(都道府県、市区町村)に当てはまる求人件数の表示を更新 */
  const refreshPositionTypeSearchCount = () => {
    refreshSearchCount('#position-type-search-count', () => {
      const selectedPositionTypes = $('input[type=checkbox]:checked', '#position-type-search-popup');
      const positionTypeIds = [];
      selectedPositionTypes.map((_, element) => {
        positionTypeIds.push({ name: 'search_condition[position_type_id_array][]', value: $(element).val() })
      });
      return bindingFormParamsOnCheckboxChanged('position_type_id_array', positionTypeIds);
    });
  };

  /* モーダルを呼び出す */
  const callPositionTypeSearchModal = () => {
    const dialog = $("#position-type-search-popup");
    bindingForm.positionTypeSearchPath(urlWithSearchQuery(bindingForm.positionTypeSearchPath(), bindingFormParams()));
    dialog.load(bindingForm.positionTypeSearchPath(), () => {
      refreshSearchCount('#position-type-search-count', () => bindingFormParams());
      dialog.modal('show');
      $('.m3p-modal__btn').text('選択した条件で絞り込む');
    });
  }

  /* モーダルを`条件を設定した上で`閉じる */
  const applyPositionTypeToSearchCondition = () => {
    const selectedPositionTypes = $('input[type=checkbox]:checked', '#position-type-search-popup');
    const positionTypeIds = [];
    selectedPositionTypes.map((_, element) => positionTypeIds.push($(element).val()));
    bindingForm.position_type_id_array(positionTypeIds);
    changeBindingTextOnSearchModule('position-type-checkbox', 'positionTypeText', '業種');
    closeModal();
  } 

  $(document).on('click', '#position-type-search-button', () => callPositionTypeSearchModal());
  $(document).on('change', '#position-type-search-popup input[type=checkbox]', refreshPositionTypeSearchCount);
  $(document).on('click', '#submit-position-type-search', applyPositionTypeToSearchCondition);

  /*******************************************
    検索条件(都道府県セレクト時)
  *******************************************/
    
  // .app-auto-reloadが変更されると指定箇所を自動リロード
  $(document).on('change', '.app-auto-reload', e => {
    const changed = $(e.currentTarget);
    const reloadContainer = $(changed.data('to'));
    // モーダルを開いている間はbinding_formの値は一切更新しないようにしている。
    // ただArea検索条件を決める場合、bindingFormParamsのタイミングで全国が選択されているにも関わらず
    // 都道府県検索モードとして扱われるケースがでてくる
    // このため、一時的にbinding_formの都道府県を更新することで適切な検索モードに切り替えた上で求人票件数の検索を行わせる
  
    const params = $(e.currentTarget).closest('form').serializeArray();
    const selectedPrefectureId = changed.val().length > 0 ? parseInt(changed.val()) : null;
    const actualPrefectureId = bindingForm.prefecture_id();
    bindingForm.prefecture_id(selectedPrefectureId);
    params.push({ name: changed.data('param'), value: changed.val() });
    const url = urlWithSearchQuery(changed.data('path'), bindingFormParams(params));
    bindingForm.citiesSearchPath(url);
    reloadContainer.load(url, () => {
      refreshAreaSearchCount();
      placeInactiveClassToCallingModalButton('#city-search-button', isEnableToCallCityModal());
      bindingForm.prefecture_id(actualPrefectureId);
      $('.m3p-modal__btn').text('選択した条件で絞り込む');
    });
  });
  
  /*******************************************
    各htmlテンプレートの再描画・更新処理
    ページ読み込み時、検索条件変更時に発動
  *******************************************/

  const bindingFormParams = (optionalParams = {}) => {
    const params = [];
    params.push({ name: 'search_condition[sm]', value: searchMode() });
    
    Object.keys(formValues).map(key => {
      if(typeof bindingForm[key]() === 'object'){
        if(bindingForm[key]() === null) return;
        bindingForm[key]().map(bindingItem => {
          params.push({ name: `search_condition[${key}][]`, value: bindingItem });
        });
      }else{
        params.push({ name: `search_condition[${key}]`, value: bindingForm[key]() });
      }
    });
    return params.concat(optionalParams);
  }

  const bindingFormParamsOnCheckboxChanged = (mode, optionalParams = {}) => {
    const params = bindingFormParams().filter(param => param.name !== `search_condition[${mode}][]`);
    return params.concat(optionalParams);
  }

  const searchMode = () => {
    if(!bindingForm.prefecture_id()) {
      return '0';
    } else if(bindingForm.city_id_array().length <= 0) {
      return '1';
    } else {
      return '2';
    }
  }

  const placeInactiveClassToCallingModalButton = (element, criterionFormula) => {
    const button = $(element);
    if(criterionFormula){
      button.removeClass('m3p-topsearch__inactive');
    }else{
      button.addClass('m3p-topsearch__inactive');
    }
  }

 const urlWithSearchQuery = (url, query) => {
    const plainUrl = url.split('?').length > 0 ? url.split('?')[0] : url;
    return `${plainUrl}?${$.param(query)}`;
  }

  function Form(formData, needsCounts) {
    Object.keys(formData).map(key => {
      this[key] = ko.observable();
    })
    this.needsCounts = ko.observable();
  
    this.update(formData, needsCounts);
  }
  $.extend(Form.prototype, {
    update(formData, needsCounts) {
      Object.keys(formData).map(key => {
        const value = formData[key];
        this[key](value);
      });
      this.needsCounts(needsCounts);
    },
    countOf(name, code){
      return this[name]()[code] || 0;
    },
    hasCode(name, code){
      return $.inArray(code, this[name]()) >= 0;
    }
  });

  /*******************************************
    検索モジュールに表示する条件を変更する
  *******************************************/

  const changeBindingTextOnSearchModule = (className, bindingText, defaultText) => {
    const newBindingText = [];
    $(`input.${className}[type=checkbox]:checked`).map((_, element) => {
      const checnedText = $(element).next().text().split('(')[0];
      newBindingText.push(checnedText);
    });
    if(newBindingText.length > 0){
      bindingForm[bindingText](newBindingText.join('、'));
    }else{
      bindingForm[bindingText](defaultText);
    }
  }
  
  const initialData = JSON.parse($("#initial-form-binding").attr('data'));
  const form_binding_json = initialData.form_binding;
  const needs_aggs_json = initialData.needs_aggs;

  // Vueにおけるprops
  const formValues = {
    prefecture_id: form_binding_json.prefectureId || "",
    city_id_array: form_binding_json.cityIdArray || [],
    employment_status_id_array: form_binding_json.employmentStatusIdArray || [],
    position_type_id_array: form_binding_json.positionTypeIdArray || [],
    action_type: form_binding_json.actionType,
    primary_sort_by: form_binding_json.primarySortBy
  }

  // Vueにおけるnew Vue
  const bindingForm = new Form(
    Object.assign(form_binding_json, formValues),
    needs_aggs_json
  );

  ko.applyBindings(bindingForm);
  // 最後の検索条件が最寄駅検索の場合、smが5にセットされるのだが、topページからだと本来使えない検索条件が組み立てられ、urlエラー(500)が発生してしまう。
  // ページ読み込み時に検索モード(sm)を(前回の検索条件に都道府県が含まれているか確認した上で)初期化を行う
  bindingForm.sm(searchMode());

  placeInactiveClassToCallingModalButton('#city-search-button', isEnableToCallCityModal());
});
